import {
    Component,
    inject,
    Signal,
    OnDestroy,
    OnInit,
    Renderer2,
    signal,
    computed,
} from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { IqTrendlinesFuelCardComponent } from '@dat/iq-trendlines-fuel';
import { IqTrendlinesSnapshotTableComponent } from '@dat/iq-trendlines-snapshot';
import { IqTrendlinesNtlSpotVanComponent, IqTrendlinesNtlSpotReeferComponent , IqTrendlinesNtlSpotFlatbedComponent} from '@dat/iq-trendlines-ntl-spot';
import { IqCarrierResourcesStateService } from '../state';
@Component({
    selector: 'iq-carrier-resources-dashboard',
    standalone: true,
    imports: [
        CommonModule,
        IqTrendlinesFuelCardComponent,
        IqTrendlinesSnapshotTableComponent,
        IqTrendlinesNtlSpotVanComponent,
        IqTrendlinesNtlSpotReeferComponent,
        IqTrendlinesNtlSpotFlatbedComponent
    ],
    templateUrl: './iq-carrier-resources-dashboard.component.html',
    styleUrl: './iq-carrier-resources-dashboard.component.scss',
})
export class IqCarrierResourcesDashboardComponent implements OnInit, OnDestroy {
    private renderer: Renderer2 = inject(Renderer2);
    private document: Document = inject(DOCUMENT);
    private _state = inject(IqCarrierResourcesStateService);

    spotBlurbSignal: Signal<string> = signal('--');
    spotBlurb: Signal<string> = computed((): string => {
        console.log('spotBlurbSignal', this.spotBlurbSignal());
        return this.spotBlurbSignal();
    });

    ngOnInit(): void {
        this.renderer.addClass(this.document.body, 'bg-black'); // Need this to override the default Trendlines background
        this._setSpotBlurbSignal();
    }

    ngOnDestroy(): void {
        this.renderer.removeClass(this.document.body, 'bg-black'); // Clean up the class when the component is destroyed
    }

    private _setSpotBlurbSignal(): void {
        this.spotBlurbSignal = this._state.spotBlurb();
    }
}
